<!--
센터 대금상환 스캔창 (TASK-161 §0-17 — 라운드 ⓒ)
------------------------------------
 - 페이지 로드 시 자동 포커스 (기존 값은 전체 선택 — 연속 스캔 시 덮어쓰기)
 - Enter = 소속 form submit (GET 검색) · 트래킹 포함검색은 서버 (Search\CodPaymentList whereTrackingNo)
 - 결과 없음 = 빈 목록 (서버 그대로)
-->
<template>
    <input ref="input"
           class="uk-input uk-form-large cdp-scan-input"
           type="text"
           :name="name"
           :value="value"
           :placeholder="placeholder"
           autocomplete="off"
           @keydown.enter.prevent="submit"/>
</template>

<script>
    export default {
        props: {
            // input name
            name: {
                type: String,
                default: 'tracking_no',
            },

            // 현재 검색값
            value: {
                type: String,
                default: '',
            },

            placeholder: {
                type: String,
                default: '트래킹번호 스캔 또는 입력 후 Enter',
            },
        },
        data: function () {
            return {
                focusDone: false,
                focusObserver: null,
                focusTimer: null,
                focusLoadHandler: null,
            };
        },
        mounted() {
            // layouts/base.blade.php: Vue 마운트 전 #app.hide (visibility:hidden) → ajax done 시점에 removeClass('hide').
            // hide 상태에서는 focus() 가 무시되므로 (R14 실측 activeElement=BODY) 해제 시점까지 재시도한다.
            this.$nextTick(() => {
                if (this.tryFocus()) {
                    return;
                }

                // #app 노드는 Vue 마운트로 교체될 수 있어 (R15 실측: 개별 노드 observe 는 해제 신호를 놓침) 문서 전체의 class 변경을 관찰한다.
                if (typeof MutationObserver !== 'undefined') {
                    this.focusObserver = new MutationObserver(() => this.tryFocus());
                    this.focusObserver.observe(document.documentElement, {attributes: true, attributeFilter: ['class'], subtree: true});
                }

                // 폴백 — load · requestAnimationFrame 2회 · 최종 setTimeout 300ms
                this.focusLoadHandler = () => this.tryFocus();
                window.addEventListener('load', this.focusLoadHandler);
                window.requestAnimationFrame(() => {
                    this.tryFocus();
                    window.requestAnimationFrame(() => this.tryFocus());
                });
                // 최종 300ms 1회 시도. #app 해제가 느린 환경 (ajax 지연) 대비 observer 는 15초 후 해제.
                window.setTimeout(() => this.tryFocus(), 300);
                this.focusTimer = window.setTimeout(() => this.stopFocusRetry(), 15000);
            });
        },
        beforeDestroy() {
            this.stopFocusRetry();
        },
        methods: {
            /**
             * 포커스 시도 (기존 값은 전체 선택). 성공 시 재시도 장치 해제.
             * @return boolean
             */
            tryFocus() {
                if (this.focusDone) {
                    return true;
                }
                let input = this.$refs.input;
                if (! input) {
                    return false;
                }
                input.focus();
                if (document.activeElement !== input) {
                    return false;
                }
                if (input.value) {
                    input.select();
                }
                this.focusDone = true;
                this.stopFocusRetry();
                return true;
            },

            stopFocusRetry() {
                if (this.focusObserver) {
                    this.focusObserver.disconnect();
                    this.focusObserver = null;
                }
                if (this.focusLoadHandler) {
                    window.removeEventListener('load', this.focusLoadHandler);
                    this.focusLoadHandler = null;
                }
                if (this.focusTimer) {
                    window.clearTimeout(this.focusTimer);
                    this.focusTimer = null;
                }
            },

            submit() {
                let input = this.$refs.input;
                if (input && input.form) {
                    input.form.submit();
                }
            },
        },
    }
</script>

<style scoped>
    .cdp-scan-input {
        font-size: 1.25rem;
        max-width: 32rem;
    }
</style>
